import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import './assets/master.css';
import RButton from './components/RButton.vue';


const app = createApp(App);

app.component('r-button', RButton);

app.use(router).mount('#app');
